import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-glyphicon',
	templateUrl:'./GlyphiconPluginCompPage.html',
	styles: [],
	styleUrls:['./GlyphiconPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class GlyphiconPluginCompPage
{
	mdContent_976 = `\`\`\`java
import com.jwebmp.plugins.glyphicons.Glyphicon;
\`\`\``;
	mdContent_977 = `\`\`\`java
Glyphicons icon
\`\`\``;
	mdContent_978 = `\`\`\`java
var icon = new Glyphicon&lt;&gt;(Glyphicons.home);
\`\`\``;
}
